import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { type OfferRead } from 'entities/Brand';

interface IBrandSlice {
	offer: OfferRead | null;
	isOpenDetailsPopup: boolean;
	visitedOffers: string[];
}

const initialState: IBrandSlice = {
	offer: null,
	isOpenDetailsPopup: false,
	visitedOffers: [],
};

export const brandSlice = createSlice({
	name: 'brand',
	initialState,
	reducers: {
		setOffer: (state, action: PayloadAction<OfferRead | null>) => {
			state.offer = action.payload;
		},
		setIsOpenDetailsPopup: (state, action: PayloadAction<boolean>) => {
			state.isOpenDetailsPopup = action.payload;
			if (!action.payload) {
				state.offer = null;
			}
		},
		setVisitedOffer: (state, action: PayloadAction<string>) => {
			state.visitedOffers = state.visitedOffers.concat(action.payload);
		},
	},
});

export default brandSlice.reducer;

export const { setOffer, setIsOpenDetailsPopup, setVisitedOffer } = brandSlice.actions;
